import React from "react";
import './footer.css';

function Footer () {
    return (
        <footer>
            <p>Copyright 2024 Argent Bank</p>
        </footer>
    )
}

export default Footer